import { error } from "@sveltejs/kit";
import { a as authServer } from "../../../chunks/auth-server.js";
import { a as userSignInSchema } from "../../../chunks/validation.js";
import { B as BETTER_AUTH_SESSION_COOKIE } from "../../../chunks/index3.js";
import { c as cookieStrToObj } from "../../../chunks/utils2.js";
import { v as validateBodyMiddleware } from "../../../chunks/middleware.js";
const actions = {
  async default(event) {
    const body = await validateBodyMiddleware(userSignInSchema, event);
    const authResponse = await authServer.api.signInEmail({
      body,
      headers: event.request.headers,
      asResponse: true
    });
    const data = await authResponse.json();
    if (!authResponse.ok) {
      error(authResponse.status, data.message);
    }
    const setCookieHeader = authResponse.headers.get("set-cookie") ?? "";
    const cookiesObj = cookieStrToObj(setCookieHeader);
    event.cookies.set(BETTER_AUTH_SESSION_COOKIE, cookiesObj[BETTER_AUTH_SESSION_COOKIE], {
      path: "/",
      ...cookiesObj
    });
    return data;
  }
};
export {
  actions
};
